import React, { useState, useEffect } from "react";

import { useFormikContext } from "formik";
import { Delete } from "icons";

import { Button, Typography } from "clearsense-ui/components";
import { Input, Textarea, DatePicker } from "clearsense-ui/components/formik";
import ContentBox from "components/Common/ContentBox";

const AddNewValue = ({
  valueIndex,
  isEditValue,
  onValueClose,
  removeValue,
  setReferenceValues,
}) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const [showError, setShowError] = useState(false);
  const [oldValues, setOldValues] = useState([]);

  const handleSave = () => {
    setShowError(true);
    if (!(errors.referenceValues && errors.referenceValues[valueIndex])) {
      setReferenceValues(values.referenceValues);
      onValueClose();
    }
  };

  const handleDelete = () => {
    removeValue(valueIndex);
    setReferenceValues(referenceValues =>
      referenceValues.filter((value, index) => index !== valueIndex)
    );
    onValueClose();
  };

  const handleCancel = () => {
    if (!isEditValue) {
      removeValue(valueIndex);
    } else {
      setFieldValue("referenceValues", oldValues);
    }
    onValueClose();
  };

  useEffect(() => {
    if (isEditValue) {
      setOldValues(values.referenceValues);
    }
  }, []);
  return (
    <ContentBox className="w-full flex flex-col gap-2 mb-2">
      <Typography className="text-gray-500">
        {!isEditValue ? "Add a New Value" : "Edit Value"}
      </Typography>
      <Input
        name={`referenceValues.${valueIndex}.name`}
        label="Value Name"
        placeholder="Enter a Value Name"
        error={
          showError &&
          errors.referenceValues &&
          errors.referenceValues[valueIndex]?.name
        }
        required
        data-cy="value-name-input-field"
      />
      <Textarea
        name={`referenceValues.${valueIndex}.description`}
        label="Value Description"
        rows={3}
        placeholder="Enter a Description for the value"
        data-cy="value-description-text-area"
      />
      <DatePicker
        name={`referenceValues.${valueIndex}.start_date`}
        dateFormat="YYYY-MM-DD"
        label="Effective Start Date"
      />
      <DatePicker
        name={`referenceValues.${valueIndex}.end_date`}
        dateFormat="YYYY-MM-DD"
        label="Effective End Date"
      />
      <div className="flex items-center">
        <Button
          label="Save Value"
          onClick={handleSave}
          data-cy="save-value-button"
        />
        <Button label="Cancel" style="text" onClick={handleCancel} />
        {isEditValue && (
          <Button
            icon={Delete}
            className="text-red-600"
            style="secondary"
            onClick={handleDelete}
          />
        )}
      </div>
    </ContentBox>
  );
};

export default AddNewValue;
